import React, { Component } from 'react';
import Heading from "../elements/Heading";
import globals from '../globals';

class TwinColumn extends Component {
    
    constructor(props) {
        super(props);

        this.state = {
            title: '',
            subTitle: '',
            column1: [],
            column2: []
        };
    }

    componentDidMount() {
        this.controller = globals.genericAnimation(this.content);
    }

    componentWillUnmount() {
        globals.destroy(this.controller);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data !== this.props.data) {
            this.setState(this.props.data);
        }
    }

    render() {
        const Column1 = this.state.column1.map((row, key) => {
            return (
                <p key={key} dangerouslySetInnerHTML={{__html: row}} />
            );
        });

        const Column2 = this.state.column2.map((row, key) => {
            return (
                <p key={key} dangerouslySetInnerHTML={{__html: row}} />
            );
        });
        
        return (
            <section className="twin-column">
                <div className="inner">
                    <div ref={el => this.content = el}>
						{this.state.title ?
							<div className="row">
								<div className="col-xs-12 centered">
									<Heading title={this.state.title} subTitle={this.state.subTitle} />
								</div>
							</div>
						: ''}
                        <div className="row">
                            <div className="col-md-8 col-md-offset-2 col-xs-12">
                                <div className="columns">
                                    <div className="column">
										{this.props.heading1}
                                        {Column1}
										{this.props.list1}
                                    </div>

                                    <div className="column">
										{this.props.heading2}
                                        {Column2}
										{this.props.list2}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
					{this.props.children}
                </div>
                <div className="bottom-wave-darkgreen" />
            </section>
        );
    }
    
}

export default TwinColumn;


// WEBPACK FOOTER //
// ./resources/assets/js/modules/TwinColumn.js